export const USER_DATA = "@user/user_data";
export const USER_UUID = "@user/user_uuid";